// VisitorTracker.js mit verbesserter Endzeit-Erfassung
import { useEffect, useRef } from "react";
import {
  getDatabase,
  ref,
  push,
  serverTimestamp,
  update,
} from "firebase/database";
import { getAuth, signInAnonymously } from "firebase/auth";

const getDeviceType = () => {
  const ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return "Tablet";
  }
  if (
    /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      ua
    )
  ) {
    return "Smartphone";
  }
  return "Desktop";
};

const VisitorTracker = () => {
  const visitRefKey = useRef(null);

  // Ping-Funktion, die regelmäßig die letzte Aktivitätszeit aktualisiert
  const updateLastActive = () => {
    if (visitRefKey.current) {
      const db = getDatabase();
      update(ref(db, `visits/${visitRefKey.current}`), {
        lastActive: serverTimestamp(),
      });
    }
  };

  // Endzeit speichern
  const recordEndTime = () => {
    if (visitRefKey.current) {
      const db = getDatabase();
      update(ref(db, `visits/${visitRefKey.current}`), {
        endTime: serverTimestamp(),
      });
    }
  };

  useEffect(() => {
    const trackVisit = async () => {
      // Wenn Admin eingeloggt ist, nicht tracken!
      if (localStorage.getItem("isAdmin") === "true") {
        console.log("Admin visit - not tracking.");
        return;
      }

      try {
        const auth = getAuth();
        const db = getDatabase();

        // Anonyme Authentifizierung
        await signInAnonymously(auth);

        // Neue Besuchs-ID generieren
        const visitRef = push(ref(db, "visits"));
        visitRefKey.current = visitRef.key;

        // Startzeit und Gerät speichern
        const deviceType = getDeviceType();
        await update(visitRef, {
          startTime: serverTimestamp(),
          deviceType: deviceType,
          lastActive: serverTimestamp(),
        });

        // Mehrere Event-Listener für verschiedene "Verlassen"-Szenarien
        window.addEventListener("beforeunload", recordEndTime);
        window.addEventListener("pagehide", recordEndTime);
        window.addEventListener("visibilitychange", () => {
          if (document.visibilityState === "hidden") {
            recordEndTime();
          }
        });

        // Regelmäßiges Update der "lastActive"-Zeit
        const pingInterval = setInterval(updateLastActive, 60000); // Alle 60 Sekunden

        // Cleanup
        return () => {
          window.removeEventListener("beforeunload", recordEndTime);
          window.removeEventListener("pagehide", recordEndTime);
          window.removeEventListener("visibilitychange", recordEndTime);
          clearInterval(pingInterval);
          recordEndTime();
        };
      } catch (error) {
        console.error("Fehler beim Tracking des Besuchs:", error);
      }
    };

    trackVisit();
  }, []);

  // Keine Ausgabe im DOM
  return null;
};

export default VisitorTracker;
